import React from 'react';
import styled from '@emotion/styled';
import { withTheme } from '@emotion/react';
import { NavLink } from 'react-router-dom';

import { Grid, AppBar as MuiAppBar, IconButton as MuiIconButton, Toolbar, Typography, Box } from '@mui/material';

import { Menu as MenuIcon } from '@mui/icons-material';

import logo from '../../vendor/pinpoint_white.png';
// import NavbarLanguagesDropdown from './NavbarLanguagesDropdown';
import NavbarUserDropdown from './NavbarUserDropdown';
// import ChooseSiteDropdown from '../ChooseSiteDropdown';
// import useAuth from '../../hooks/useAuth';

const AppBar = styled(MuiAppBar)`
  background: ${(props) => props.theme.header.background};
  color: ${(props) => props.theme.header.color};
`;

const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
`;

const BrandContainer = styled(Box)`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: 8px;
  
  img {
    max-height: 28px;
    filter: brightness(0) saturate(100%);
  }
`;

const BrandText = styled(Typography)`
  font-size: 1.1rem;
  font-weight: 500;
  color: ${(props) => props.theme.header.color};
  white-space: nowrap;
`;

const Navbar = ({ onDrawerToggle }) => (
  // const { userMe } = useAuth();
  // const { t } = useTranslation();
  <AppBar position="sticky" elevation={0}>
    <Toolbar>
      <Grid container alignItems="center">
        <Grid item>
          <IconButton
            color="inherit"
            aria-label="Open drawer"
            onClick={onDrawerToggle}
            size="large">
            <MenuIcon />
          </IconButton>
        </Grid>
        <Grid item>
          <BrandContainer component={NavLink} to="/" sx={{ textDecoration: 'none' }}>
            <img src={logo} alt="Pinpoint Logo" />
            <BrandText>Mina sidor</BrandText>
          </BrandContainer>
        </Grid>
        <Grid item xs />
        {/* {userMe === 'user' && <ChooseSiteDropdown />} */}
        <Grid item>
          {/* <NavbarLanguagesDropdown /> */}
          <NavbarUserDropdown />
        </Grid>
      </Grid>
    </Toolbar>
  </AppBar>
);
export default withTheme(Navbar);
